var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.376 10.643c0 .44.343.859.924.859.3 0 .547-.161.773-.344l1.396-1.181v10.248c0 1.503.892 2.374 2.428 2.374h14.534c1.526 0 2.417-.87 2.417-2.374V9.9l1.494 1.257c.214.183.461.344.762.344.505 0 .913-.312.913-.827a.878.878 0 00-.333-.73L22.848 7.56V3.112c0-.472-.3-.773-.773-.773h-1.15c-.461 0-.773.3-.773.773v2.181L14.502.545c-.795-.677-1.784-.677-2.59 0L.72 9.945a.898.898 0 00-.343.698zm15.92 3.029c0-.494-.323-.817-.817-.817h-4.554c-.505 0-.828.323-.828.817v7.197H6.262c-.687 0-1.063-.387-1.063-1.085V8.526l7.627-6.391c.236-.215.526-.215.763 0l7.53 6.316v11.333c0 .698-.376 1.085-1.053 1.085h-3.77v-7.197z",
    fill: "inherit"
  })));
}

export default SvgHomeinline;